/* eslint-disable*/
/*
 * @Author       : dxy
 * @Date         : 2020-12-03 15:24:00
 * @LastEditors  : dxy
 * @LastEditTime : 2020-12-18 11:17:57
 * @Descripttion : utils.js 临时文件，utils方法全部改写后删除
 */
import moment, { Moment } from 'moment';
import { parse, stringify } from 'qs';
import { i18n, Fishx, setLang as setLocale, matchPath } from 'fishx';
import defaultSettings from '@config/defaultSettings';
import loginSession from './loginSession';

const { themeConfig, publicPath } = defaultSettings;
const prefix = themeConfig['@ant-prefix'];

/**
 * @description: 获取静态资源前缀，dev 的时候 publicPath 必须是 '/'
 * @param
 * @return {string}
 */
export const getPublicPath = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return '/';
  }
  return publicPath.slice(-1) === '/' ? publicPath : `${publicPath}/`;
};

/**
 * 某link标签是否存在，不存在则添加，目前用于换肤
 * @param {string} id的值
 */
export function getTag(flag: string): Partial<HTMLLinkElement> {
  let styleLink: Partial<HTMLLinkElement> = document.getElementById(flag) ?? {};
  // 判断加装皮肤的标签是否存在,不存在需要创建
  if (!styleLink) {
    styleLink = document.createElement('link');
    styleLink.type = 'text/css';
    styleLink.rel = 'stylesheet';
    styleLink.id = flag;
  }
  return styleLink;
}

export const getRemoteProxyPrefix = (url: string) => {
  // @ts-ignore
  // eslint-disable-next-line no-undef
  if ((process.env && process.env.NODE_ENV === 'development') || SEPARATION_FLAG) {
    if (url.indexOf('/') === 0) return `FishModule${url}`;
    return `FishModule/${url}`;
  }
  return url;
};

export const getFishxProxyPrefix = (url: string) => {
  // @ts-ignore
  // eslint-disable-next-line no-undef
  if ((process.env && process.env.NODE_ENV === 'development') || SEPARATION_FLAG) {
    if (url.indexOf('/') === 0) return `FishxModule${url}`;
    return `FishxModule/${url}`;
  }
  return url;
};

export const getIframeProxyPrefix = (url: string) => {
  // @ts-ignore
  // eslint-disable-next-line no-undef
  if ((process.env && process.env.NODE_ENV === 'development') || SEPARATION_FLAG) {
    return `FishModule/remote.html?${url}`;
  }
  return url;
};

export function fixedZero(val: number): number | string {
  return val * 1 < 10 ? `0${val}` : val;
}

export function getTimeDistance(type: string): [Moment, Moment] {
  const now = new Date();
  const oneDay = 1000 * 60 * 60 * 24;

  if (type === 'today') {
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    return [moment(now), moment(now.getTime() + (oneDay - 1000))];
  }

  if (type === 'week') {
    let day = now.getDay();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);

    if (day === 0) {
      day = 6;
    } else {
      day -= 1;
    }

    const beginTime = now.getTime() - day * oneDay;

    return [moment(beginTime), moment(beginTime + (7 * oneDay - 1000))];
  }

  if (type === 'month') {
    const year = now.getFullYear();
    const month = now.getMonth();
    const nextDate = moment(now).add(1, 'months');
    const nextYear = nextDate.year();
    const nextMonth = nextDate.month();

    return [
      moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`),
      moment(moment(`${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`).valueOf() - 1000),
    ];
  }

  if (type === 'lastWeek') {
    let day = now.getDay();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);

    if (day === 0) {
      day = 6;
    } else {
      day -= 1;
    }

    const endTime = now.getTime() - (day * oneDay + 1000);
    return [moment(endTime - (7 * oneDay - 1000)), moment(endTime)];
  }

  if (type === 'lastMonth') {
    const year = now.getFullYear();
    const month = now.getMonth();
    const lastDate = moment(now).subtract(1, 'months');
    const lastYear = lastDate.year();
    const LastMonth = lastDate.month();
    return [
      moment(`${lastYear}-${fixedZero(LastMonth + 1)}-01 00:00:00`),
      moment(moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`).valueOf() - 1000),
    ];
  }

  const year = now.getFullYear();
  return [moment(`${year}-01-01 00:00:00`), moment(`${year}-12-31 23:59:59`)];
}

export function getPlainNode(nodeList: object[], parentPath: string = ''): any[] {
  const arr: Array<Object> = [];
  nodeList.forEach((node: any) => {
    const item = node;
    item.path = `${parentPath}/${item.path || ''}`.replace(/\/+/g, '/');
    item.exact = true;
    if (item.children && !item.component) {
      arr.push(...getPlainNode(item.children, item.path));
    } else {
      if (item.children && item.component) {
        item.exact = false;
      }
      arr.push(item);
    }
  });
  return arr;
}

export function getRelation(str1: string, str2: string): number {
  if (str1 === str2) {
    console.warn('Two path are equal!'); // eslint-disable-line
  }
  const arr1 = str1.split('/');
  const arr2 = str2.split('/');
  if (arr2.every((item, index) => item === arr1[index])) {
    return 1;
  }
  if (arr1.every((item, index) => item === arr2[index])) {
    return 2;
  }
  return 3;
}

export function getRenderArr(routes: Array<any>): Array<any> {
  let renderArr: Array<any> = [];
  renderArr.push(routes[0]);
  for (let i = 1; i < routes.length; i += 1) {
    // 去重
    renderArr = renderArr.filter(item => getRelation(item, routes[i]) !== 1);
    // 是否包含
    const isAdd = renderArr.every(item => getRelation(item, routes[i]) === 3);
    if (isAdd) {
      renderArr.push(routes[i]);
    }
  }
  return renderArr;
}

/**
 * Get router routing configuration
 * { path:{name,...param}}=>Array<{name,path ...param}>
 * @param {string} path
 * @param {routerData} routerData
 */
export function getRoutes(path: string, routerData: object) {
  let routes = Object.keys(routerData).filter(routePath => routePath.indexOf(path) === 0 && routePath !== path);
  // Replace path to '' eg. path='user' /user/name => name
  routes = routes.map(item => item.replace(path, ''));
  // Get the route to be rendered to remove the deep rendering
  const renderArr = getRenderArr(routes);
  // Conversion and stitching parameters
  const renderRoutes = renderArr.map(item => {
    const exact = !routes.some(route => route !== item && getRelation(route, item) === 1);
    return {
      exact,
      ...routerData[`${path}${item}`],
      key: `${path}${item}`,
      path: `${path}${item}`,
    };
  });
  return renderRoutes;
}

export function getPageQuery() {
  return parse(window.location.href.split('?')[1]);
}

export function getQueryPath(path: string = '', query: object = {}): string {
  const search = stringify(query);
  if (search.length) {
    return `${path}?${search}`;
  }
  return path;
}
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
export function isUrl(path: string): boolean {
  return reg.test(path);
}

export function formatWan(val: any) {
  const v = val * 1;
  if (!v || Number.isNaN(v)) return '';

  let result = val;
  if (val > 10000) {
    result = Math.floor(val / 10000);
    result = `<span>
        ${result}
        <span
          styles={{
            position: 'relative',
            top: -2,
            fontSize: 14,
            fontStyle: 'normal',
            lineHeight: 20,
            marginLeft: 2,
          }}
        >
          万
        </span>
      </span>`;
  }
  return result;
}

export function menuAdapter(srcData: any, key: any, parentKey: any, children: any): any[] {
  if (!key || key === '' || !srcData) return [];

  if (Array.isArray(srcData)) {
    const r: any[] = [];
    const tmpMap: any[] = [];
    srcData.forEach(v => {
      tmpMap[v[key]] = v;
    });

    srcData.forEach(v => {
      const val = v;
      val.name = val.partyName;
      // 如果是fish菜单,path改成pageCode
      if (val.menuType === 'S' && (val?.url.indexOf('modules/') !== -1 || val?.url.indexOf('wfm/') !== -1)) {
        val.path = `/${val.privCode}`;
      } else if (val.menuType === 'R') {
        val.path = `/${val.privCode}`;
      } else if (val.menuType === 'I') {
        // 远程iframe类型的菜单要单独特殊处理一下
        val.path = `/iframeModule/${val.privCode}`;
      } else if (val.menuType === 'D') {
        val.path = `/DynamicModule/${val.privCode}`;
      } else {
        val.path = `${val.url ? val.url : val.partyId}`;
      }
      if (val.path.indexOf('/') !== 0) val.path = `/${val.path}`;
      if (tmpMap[v[parentKey]] && v[key] !== v[parentKey]) {
        if (!tmpMap[v[parentKey]][children]) tmpMap[v[parentKey]][children] = [];
        tmpMap[v[parentKey]][children].push(v);
      } else {
        r.push(v);
      }
    });
    return r;
  }
  return [srcData];
}

export const arrayToTree = (array: any[] = [], key: any = 'key', parentKey: any = 'parentKey', children: any = 'children'): any[] => {
  if (!Array.isArray(array)) return [array];
  const tree: any[] = [];
  const dict: object = {};
  array.forEach(v => {
    dict[v[key]] = v;
  });

  array.forEach(v => {
    if ((v[parentKey] || v[parentKey] === 0) && dict[v[parentKey]]) {
      if (!dict[v[parentKey]][children]) {
        dict[v[parentKey]][children] = [];
      }
      dict[v[parentKey]][children].push(v);
    } else {
      tree.push(v);
    }
  });
  return tree;
};

/**
 * 数组对象全等判断
 * @param {array} a1
 * @param {array} a2
 */
export function compareArray(a1: Array<any>, a2: Array<any>): boolean {
  let flag = true;
  if (a1 === a2) flag = true;
  if ((!a1 && a2) || (a1 && !a2)) flag = false;
  if (a1.length !== a2.length) flag = false;
  a1.forEach((item, index) => {
    if (JSON.stringify(item) !== JSON.stringify(a2[index])) flag = false;
  });
  return flag;
}

/**
 * table sort排序格式化
 * @param {object} sorter
 */
interface Sorter {
  columnKey: string | number;
  order: string;
}
export function formatTableSort(sorter: Sorter) {
  let orderFields;
  if (sorter.columnKey) {
    orderFields = `${sorter.columnKey} ${sorter.order === 'descend' ? 'desc' : 'asc'}`;
  }
  return orderFields;
}

export function getWebRoot(): string {
  let webroot: string = document.location.href;
  if (webroot.indexOf('#') < 0) {
    return BASE_NAME;
  }
  webroot = webroot.substring(webroot.indexOf('//') + 2, webroot.length);
  webroot = webroot.substring(webroot.indexOf('/') + 1, webroot.length);
  webroot = webroot.indexOf('#') === webroot.length - 1 ? webroot.substring(0, webroot.indexOf('#')) : webroot;
  webroot = webroot.indexOf('/') > -1 ? webroot.substring(0, webroot.indexOf('/')) : webroot;
  webroot = webroot.replace('index.html', '');
  webroot = webroot === '#' ? '' : webroot;
  const rootpath = webroot.length <= 0 ? '' : `/${webroot}`;
  return rootpath;
}

export function checkWeakPwd(pwd: string, userCode: string): boolean {
  if (userCode) {
    const pwdL = pwd.toLowerCase();
    const userCodeL = userCode.toLowerCase();
    const reversedUc = userCode
      .split('')
      .reverse()
      .join('');
    if (!(pwdL === userCodeL || pwdL === reversedUc)) {
      return true;
    }
    return false;
  }
  return true;
}

/**
 * 密码规则校验
 * @param {string} password
 * @param {object} composition 校验规则
 * @param {string} userCode 不可与用户名正反重复
 */
interface Composition<T> {
  userPwdMinLength: T;
  pwdComposition: T;
}
export function isMatchPwdRule(password: string, composition: Composition<string>, userCode: string): boolean | string {
  const userPwdMaxLength: any = 30;
  let msg: any = true;
  if (!password) {
    return i18n('LOGIN_PWD_REQUIRED');
  }
  if (/(.)\1{2}/.test(password)) {
    return i18n('LOGIN_PWD_CONTINUOUS_CHAR_NUM').replace('{0}', '2');
  }
  if (!checkWeakPwd(password, userCode)) {
    return i18n('LOGIN_PWD_NOT_USER_CODE');
  }
  if (password.length < Number(composition.userPwdMinLength) || password.length > userPwdMaxLength) {
    msg = i18n('LOGIN_PWD_LENGTH')
      .replace('{1}', composition.userPwdMinLength)
      .replace('{2}', userPwdMaxLength);
    return msg;
  }
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasSpecialChar = /[@#$%!&*]/.test(password);
  const hasDigitsChar = /[0-9]/.test(password);
  switch (composition.pwdComposition) {
    case '2':
      if (!hasDigitsChar || !(hasLowerCase || hasUpperCase)) {
        return i18n('LOGIN_PWD_COMPOTION_2');
      }
      break;
    case '3':
      if (!hasDigitsChar || !hasLowerCase || !hasUpperCase) {
        return i18n('LOGIN_PWD_COMPOTION_3');
      }
      break;
    case '4':
      if (!hasDigitsChar || !(hasLowerCase || hasUpperCase) || !hasSpecialChar) {
        return i18n('LOGIN_PWD_COMPOTION_4');
      }
      break;
    case '5':
      if (!hasDigitsChar || !hasLowerCase || !hasUpperCase || !hasSpecialChar) {
        return i18n('LOGIN_PWD_COMPOTION_5');
      }
      break;
    default:
      break;
  }
  return true;
}

/**
 * Abbreviate Name
 *
 * @param  {string}    full name
 * @return {string}    abbreviate name
 */
export function abbreviateName(name: string): string {
  if (name) {
    const regEn = /.*[A-Za-z]+.*$/;
    const regCh = /.*[\u4e00-\u9fa5]+.*$/;
    const regSpecial = /.*[\s*.*/g]+.*$/;
    const interceptName = (names: string, regs: RegExp, language: string): string | string[] | null => {
      const letterArr = names.split('');
      let firstPosition: string | number | null = null;
      let lastPosition = null;
      letterArr.map((item, index) => {
        if (regs.test(item) && !!(Number(firstPosition) >= 0)) {
          firstPosition = index;
        }
        if ((firstPosition === '0' || firstPosition) && !regs.test(item) && !regSpecial.test(item)) {
          lastPosition = index;
        }
        return item;
      });
      let newArr = null;
      if (language === 'en') {
        newArr = lastPosition
          ? names.substring(Number(firstPosition), lastPosition).split(' ')
          : names.substring(Number(firstPosition), names.length).split(' ');
      }
      if (language === 'ch') {
        newArr = lastPosition ? names.substring(Number(firstPosition), lastPosition) : names.substring(Number(firstPosition), names.length);
      }
      return newArr;
    };
    if (regEn.test(name)) {
      // 取英文结果为数组类型
      let enArr = interceptName(name, regEn, 'en');
      const newEnName: any[] = [];
      let result: string = '';
      if (Array.isArray(enArr)) {
        if (enArr.length > 2) {
          enArr = [enArr[0], enArr[enArr.length - 1]];
        }
        enArr.map(item => newEnName.push(item.substr(0, 1).toUpperCase()));
        result = newEnName.join('');
      }
      return result;
    }
    if (!regEn.test(name) && regCh.test(name)) {
      // 取中文,结果为string类型
      const chArr = interceptName(name, regCh, 'ch');
      if (chArr && typeof chArr === 'string') {
        if (chArr.length > 2) return chArr.substring(1, 3);
        if (chArr.length < 3) return chArr;
      }
    }
  }
  return '';
}

/**
 * 获取指定日期
 *
 * @param  {number}  0:今天 -1：昨天  1：明天 2：后天依次排序
 * @return {Date}
 */
export function getAppointedDate(count: number = 0): Date {
  const countN = Number(count);
  const now = new Date();
  now.setDate(now.getDate() + countN);
  return now;
}

export function setCookie(name: string, value: string, expiredays: number) {
  const exdate = new Date();

  exdate.setDate(exdate.getDate() + expiredays);
  const expire = expiredays == null ? '' : `;expires=${exdate.toUTCString()}`;
  document.cookie = `${name}=${escape(value)}${expire}; path=/`;
}

export function getCookie(cookieName: string): string | null {
  const allcookies = document.cookie;
  let cookiePos = allcookies.indexOf(cookieName);
  if (cookiePos !== -1) {
    cookiePos = cookiePos + cookieName.length + 1;
    let cookieEnd = allcookies.indexOf(';', cookiePos);

    if (cookieEnd === -1) {
      cookieEnd = allcookies.length;
    }
    return unescape(allcookies.substring(cookiePos, cookieEnd));
  }
  return null;
}

/**
 * 导出为excel
 * 未被使用的方法
 * @param  {obj}
 */
export function exportData(param: { [key: string]: string }) {
  const dlform = document.createElement('form');
  dlform.setAttribute('style', 'display:none');
  dlform.method = 'post';
  dlform.action = param.url;
  dlform.target = 'id_iframe';
  const hdnFilePath = document.createElement('input');
  hdnFilePath.type = 'hidden';
  hdnFilePath.name = 'ftfexpformat';
  hdnFilePath.value = 'xlsx';
  dlform.appendChild(hdnFilePath);

  const hdnftfexpcfg = document.createElement('input');
  hdnftfexpcfg.type = 'hidden';
  hdnftfexpcfg.name = 'ftfexpcfg';
  hdnftfexpcfg.value = param.configstr;
  dlform.appendChild(hdnftfexpcfg);

  const hdnparam = document.createElement('input');
  hdnparam.type = 'hidden';
  hdnparam.name = 'param';
  hdnparam.value = param.data;
  dlform.appendChild(hdnparam);

  // const token = loginSession.getCsrfToken();
  const currentUser = loginSession.getUser() || {};
  const { _csrf = {} } = currentUser;
  const csrfParameterName = _csrf.parameterName;
  if (csrfParameterName) {
    const tokenParam = document.createElement('input');
    tokenParam.type = 'hidden';
    tokenParam.name = csrfParameterName;
    tokenParam.value = _csrf.token;
    dlform.appendChild(tokenParam);
  }

  document.body.appendChild(dlform);
  dlform.acceptCharset = 'UTF-8';
  dlform.submit();
  document.body.removeChild(dlform);
}

export function exportTable(param: { [key: string]: any }) {
  const paramN = param;
  paramN.asyn = true;
  const { fileName, colModel } = paramN;
  paramN.configstr = JSON.stringify({ fileName, columns: colModel });
  paramN.data = JSON.stringify(paramN.serviceParam || {});
  exportData(paramN);
}

// /userinfo/2144/id => ['/userinfo','/useinfo/2144,'/userindo/2144/id']
// eslint-disable-next-line import/prefer-default-export
export function urlToList(url: string) {
  const urllist = url.split('/').filter(i => i);
  return urllist.map((_, index) => `/${urllist.slice(0, index + 1).join('/')}`);
}

export function transformFormat(format: string) {
  let formatN = format.toUpperCase();
  formatN = formatN.replace('II', 'mm');
  formatN = formatN.replace('SS', 'ss');
  return formatN;
}

export function dxpOpenMenu(url: string) {
  /* eslint-disable no-underscore-dangle */
  Fishx.history.push(url);
  // window.g_app._store.dispatch(routerRedux.push(url));
}

export function judgeIfContainCurrentRoute(pathname: string, routeData: any[]) {
  let routeAuthority = false;
  const getAuthority = (key: string, routes: any[]) => {
    routes.map(route => {
      const path = key.split('/')[1];
      if (route.path && route.path.toLowerCase().includes(path.toLowerCase())) {
        routeAuthority = true;
      } else if (matchPath(key, route)) {
        routeAuthority = true;
      } else if (route.routes) {
        routeAuthority = getAuthority(key, route.routes);
      }
      return route;
    });
    return routeAuthority;
  };
  return getAuthority(pathname, routeData);
}

// resize
/**
 * 获取页面page高度
 * @param  {string} 页面样式类前缀
 */
export function pageHeight(themePrefix: string = prefix): number {
  const screenHeight = document.documentElement.clientHeight;
  const header: HTMLElement = document.querySelector(`.${themePrefix}-layout-header`) as HTMLElement;
  const defaultHeaderHeight = 40;
  const headerHeight = header ? header.offsetHeight : defaultHeaderHeight;
  const mainContent = document.querySelector('.dxp-main-layout-content');
  const mainContentHeight = mainContent ? screenHeight - headerHeight - 2 * parseInt(window.getComputedStyle(mainContent).marginTop, 10) : 0;
  // 如果多页签模式有高度，不是高度就是0
  const multiTabBar: HTMLElement = document.querySelector(`.${themePrefix}-tabs-bar`) as HTMLElement;
  const multiTabBarHeight = multiTabBar ? multiTabBar.offsetHeight + parseInt(window.getComputedStyle(multiTabBar).marginBottom, 10) : 0;
  const multiTabPane = document.querySelector(`.${themePrefix}-tabs-tabpane-active`);
  const multiTabPanePadding = multiTabPane ? 2 * parseInt(window.getComputedStyle(multiTabPane).paddingTop, 10) : 0;
  const multiTabContent = document.querySelector('.ka-content');
  const multiTabContentPadding = multiTabContent ? 2 * parseInt(window.getComputedStyle(multiTabContent).paddingTop, 10) : 0;
  const multiTabConCalcHeight = multiTabBar ? 1 : 0;
  const bodyHeight = mainContentHeight - multiTabBarHeight - multiTabPanePadding - multiTabContentPadding - multiTabConCalcHeight;
  return bodyHeight;
}

/**
 * 获取表格sroll高度
 * @param  {string} 表格类名
 * @param  {number} 页面固定部分的高度,一般为card,form等,获取方式document.querySelector().offsetHeight
 * @param  {string} 页面样式类前缀
 */
export function gridIncHeight(gridClassName: string, fixedHeight: number = 0, themePrefix: string = prefix): number {
  const getPageHeight = pageHeight();
  const tableTitle = document.querySelector(`.${gridClassName} .${themePrefix}-table-title`) as HTMLElement;
  const tableTitleHeight = tableTitle ? tableTitle.offsetHeight : 0;
  const tableHeader = document.querySelector(`.${gridClassName} thead`) as HTMLElement;
  const tableHeaderHeight = tableHeader ? tableHeader.offsetHeight : 0;
  const defaultType = document.querySelector(`.${gridClassName} .${themePrefix}-table-default`);
  const calcTableHeader = defaultType ? 0 : 1;
  const tableBorder = document.querySelector(`.${gridClassName} .${themePrefix}-table-wrapper`);
  let calcTableborder;
  const explorer = window.navigator.userAgent;
  calcTableborder = tableBorder ? 2 * parseInt(window.getComputedStyle(tableBorder).borderWidth, 10) : 0;
  if (explorer.indexOf('Trident') > -1) {
    calcTableborder = tableBorder ? 2 * parseInt(tableBorder.currentStyle.borderWidth, 10) : 0;
  }
  if (explorer.indexOf('Edge') > -1) {
    calcTableborder = 2;
  }
  const scrollHeight = getPageHeight - fixedHeight - tableTitleHeight - tableHeaderHeight - calcTableHeader - calcTableborder;
  return scrollHeight;
}

/**
 * 获取分页表格行数pagesize
 * @param  {string} 表格类名
 * @param  {number} 页面固定部分的高度,一般为card,form等,获取方式document.querySelector().offsetHeight
 * @param  {string} 页面样式类前缀
 */
export function gridPageSize(gridClassName: string, fixedHeight: number = 0, themePrefix: string = prefix) {
  const incHeight = gridIncHeight(gridClassName, fixedHeight, themePrefix);
  // table row height
  const getTable = document.querySelector(`.${gridClassName}`);
  const tableRow = getTable ? getTable.getElementsByClassName(`${themePrefix}-table-row`) : '';
  const defaultTableRowHeight = 38;
  const tableRowHeight: number = Array.isArray(tableRow) && tableRow[0].offsetHeight !== 0 ? tableRow[0].offsetHeight : defaultTableRowHeight;
  // table pagination height
  const getTablePagination = document.querySelector(`.${gridClassName} .${themePrefix}-pagination`) as HTMLElement;
  const defaultPaginationHeight = 56;
  const tablePaginationHeight = getTablePagination
    ? getTablePagination.offsetHeight + 2 * parseInt(window.getComputedStyle(getTablePagination).marginTop, 10)
    : defaultPaginationHeight;
  const pageSizeHeight = incHeight - tablePaginationHeight;
  let pageSize = parseInt((pageSizeHeight / tableRowHeight).toString(), 10) - 1;
  pageSize = pageSize > 0 ? pageSize : 1;
  return pageSize;
}

/**
 * 获取原iconfont的type,以适合SVG的type
 * @param  {string} 类名
 */
export function getIconType(iconClassName: string): string | null {
  if (iconClassName) {
    const startPoint = iconClassName.indexOf('icon-');
    const endPoint = iconClassName.length;
    return iconClassName.substring(startPoint < 0 ? 0 : startPoint + 5, endPoint);
  }
  return null;
}

/**
 * 设置lang  cookie和localStorage
 * @param  {string} 前端存储的值
 */
export function setLang(fishxLang: string) {
  const portalLocalKey = fishxLang.indexOf('-') > -1 ? fishxLang.split('-')[0] : fishxLang;
  setCookie('ZSMART_LOCALE', portalLocalKey, 30);
  setLocale(fishxLang);
}

// 常见语言map https://ant.design/docs/react/i18n-cn
export const langMap = {
  en: 'en-US',
  zh: 'zh-CN',
  es: 'es-ES',
  fr: 'fr-FR',
  ja: 'ja-JP',
  ko: 'ko-KR',
};

export const formatMessage = ({ id }: { [key: string]: string }) => i18n(id);

// 获取浏览器信息
export function getBaseConfig(): object {
  const browser = window.navigator.userAgent;
  const url = window.location.href;
  const screenWidth = document.body.clientWidth;
  const screenHeight = document.body.clientHeight;
  const referer = document.referrer;
  const pageTitle = document.title;
  const clientScreen = `${window.screen.width}*${window.screen.height}`;

  // 判断所用浏览器
  const browserTypeFc = (): string => {
    const agent = window.navigator.userAgent.toLowerCase();
    let browserInfo = '';
    if (agent.indexOf('trident') > 0) {
      // IE
      browserInfo = 'IE';
    } else if (agent.indexOf('msie') > 0) {
      // OLD_IE
      browserInfo = 'IE';
    } else if (agent.indexOf('edge') > 0) {
      // Edge
      browserInfo = 'Edge';
    } else if (agent.indexOf('firefox') > 0) {
      // firefox
      browserInfo = 'Firefox';
    } else if (agent.indexOf('opr') > 0) {
      // Opera
      browserInfo = 'Opera';
    } else if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
      // Safari
      browserInfo = 'Safari';
    } else if (agent.indexOf('chrome') > 0) {
      // Chrome
      browserInfo = 'Chrome';
    } else {
      browserInfo = 'other';
    }
    return browserInfo;
  };

  // 获取操作系统信息
  const OSTypeFc = (): string => {
    const sUserAgent = window.navigator.userAgent.toLowerCase();

    const isWin = window.navigator.platform === 'Win32' || window.navigator.platform === 'Win64' || window.navigator.platform === 'wow64';
    if (isWin) {
      const isWin2K = sUserAgent.indexOf('Windows nt 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
      if (isWin2K) return 'Win2000';
      const isWinXP = sUserAgent.indexOf('Windows nt 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1;
      if (isWinXP) return 'WinXP';
      const isWin2003 = sUserAgent.indexOf('Windows nt 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;
      if (isWin2003) return 'Win2003';
      const isWinVista = sUserAgent.indexOf('Windows nt 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;
      if (isWinVista) return 'WinVista';
      const isWin7 = sUserAgent.indexOf('Windows nt 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;
      if (isWin7) return 'Win7';
      const isWin8 = sUserAgent.indexOf('windows nt 6.2') > -1 || sUserAgent.indexOf('Windows 8') > -1;
      if (isWin8) return 'Win8';
      const isWin10 = sUserAgent.indexOf('windows nt 10.0') > -1 || sUserAgent.indexOf('Windows 10') > -1;
      if (isWin10) return 'Win10';
    }

    const isMac =
      window.navigator.platform === 'Mac68K' ||
      window.navigator.platform === 'MacPPC' ||
      window.navigator.platform === 'Macintosh' ||
      window.navigator.platform === 'MacIntel';
    if (isMac) return 'Mac';

    const isUnix = window.navigator.platform === 'X11' && !isWin && !isMac;
    if (isUnix) return 'Unix';

    const isLinux = String(window.navigator.platform).indexOf('Linux') > -1;
    const bIsAndroid = sUserAgent.toLowerCase().indexOf('android') > -1;
    if (isLinux) {
      if (bIsAndroid) return 'Android';
      return 'Linux';
    }
    return 'other';
  };
  const OSType = OSTypeFc();
  const browserType = browserTypeFc();
  return { browser, url, screenWidth, screenHeight, pageTitle, clientScreen, referer, browserType, OSType };
}

export const getElementsByClass = (className: string): Element[] => {
  const classArr = [];
  const tags = document.getElementsByTagName('*');

  for (let i = 0; i < tags.length; i += 1) {
    // eslint-disable-line
    if (tags[i].nodeType === 1) {
      if (tags[i].className === className) {
        classArr.push(tags[i]);
      }
    }
  }

  return classArr;
};

export const encodeBase64 = (str) => {
  const _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var t = "";
  var n, r, i, s, o, u, a;
  var f = 0;
  str = _utf8_encode(str);
  while (f < str.length) {
    n = str.charCodeAt(f++);
    r = str.charCodeAt(f++);
    i = str.charCodeAt(f++);
    s = n >> 2;
    o = (n & 3) << 4 | r >> 4;
    u = (r & 15) << 2 | i >> 6;
    a = i & 63;
    if (isNaN(r)) {
      u = a = 64
    } else if (isNaN(i)) {
      a = 64
    }
    t = t + _keyStr.charAt(s) + _keyStr.charAt(o) + _keyStr.charAt(u) + _keyStr.charAt(a)
  }
  return t
};

function _utf8_encode(e) {
  e = e.replace(/rn/g, "n");
  var t = "";
  for (var n = 0; n < e.length; n++) {
    var r = e.charCodeAt(n);
    if (r < 128) {
      t += String.fromCharCode(r)
    } else if (r > 127 && r < 2048) {
      t += String.fromCharCode(r >> 6 | 192);
      t += String.fromCharCode(r & 63 | 128)
    } else {
      t += String.fromCharCode(r >> 12 | 224);
      t += String.fromCharCode(r >> 6 & 63 | 128);
      t += String.fromCharCode(r & 63 | 128)
    }
  }
  return t
};
